import SelectFieldDetails from 'components/app-grid/select-field-details';
import { DefaultGridButtonExportToExcel } from 'components/data-grid/model';
import { TemplateEmployee } from 'components/templates/template-employee';
import React from 'react';
import { permissionKey } from 'services/user-employee-profile-permissions';
import { API_USER_EMPLOYEE_PROFILES } from 'services/user-employee-profiles';
import {
  API_USER_PATIENT_PROFILE_NOTES,
  Notes,
  NotesGrid,
} from 'services/user-patient-profile-notes';
import { excelTemplateDate } from 'utils/dates';
import {
  createFilterContains,
  createFilterEquals,
  createFilterSmartSearch,
  mergeFilters,
} from 'utils/dynamic-helpers';
import { TemplateDate } from 'components/templates/template-date';

interface Options {
  userPatientProfileID: string;
}
export default (options: Options): any => ({
  store: {
    get: {
      url: API_USER_PATIENT_PROFILE_NOTES.GET_ALL_DYNAMIC,
      filters: createFilterEquals('userPatientProfileID', options.userPatientProfileID),
      selected: 'isActive',
    },
    create: {
      url: API_USER_PATIENT_PROFILE_NOTES.POST,
    },
    patch: {
      url: API_USER_PATIENT_PROFILE_NOTES.PATCH,
    },
    delete: {
      url: API_USER_PATIENT_PROFILE_NOTES.DELETE,
    },
    sortable: {
      field: 'createdDate',
      order: 'desc',
    },
  },
  controlsDropDown: [
    'edit',
    { type: 'delete', title: 'delete', permission: permissionKey('isAllowToDeleteAnything') },
  ],
  toolbar: {
    title: '',
    excelTitle: 'notes',
    filters: [
      {
        field: 'text',
        options: {
          type: 'string',
          label: 'text',
          valueTemplate: ({ value }: any) =>
            mergeFilters(
              createFilterContains<NotesGrid>(['description'], value),
              createFilterSmartSearch<NotesGrid>(
                ['userEmployeeProfile.firstName', 'userEmployeeProfile.lastName'],
                value,
              ),
            ).join('||'),
        },
      },
      {
        field: 'userEmployeeProfileID',
        options: {
          style: { minWidth: '30rem' },
          type: 'component',
          template: SelectFieldDetails,
          label: 'employee',
          source: `${API_USER_EMPLOYEE_PROFILES.GET_ALL_DYNAMIC}?Select=appIdentityUserID as id,fullName as title,isActive&orderBy=isActive desc,firstName,lastName asc`,
          option: {
            label: 'title',
            value: 'id',
          },
        },
      },
    ],
    controls: null,
    controlsDefault: {
      export: DefaultGridButtonExportToExcel,
    },
  },
  columns: [
    {
      title: 'employee',
      field: 'userEmployeeProfile.fullName as userEmployeeProfileID',
      sortable: 'userEmployeeProfile.firstName',
      template: (data: Notes) => <TemplateEmployee employee={data.userEmployeeProfileID || ''} />,
    },
    {
      title: 'description',
      field: 'description',
    },
    {
      title: 'entry-date',
      field: 'entryDate',
      template: (data: Notes) => <TemplateDate date={data.entryDate} />,
      valueTemplate: (data: Notes) => excelTemplateDate(data.entryDate),
    },
  ],
});
